<template lang="">
    <div>
		<router-view></router-view>
	</div>
</template>
<script>
    import { useAuthStore, useRegStore } from "@/store";
export default {
	data() {
		const authStore = useAuthStore();
		return {
			serviceId : this.$route.query.service_id || authStore.serviceId,
			redirectUrl : this.$route.query.redirect_url || authStore.redirectUrl,
		}
	},
	mounted() {
        const regStore = useRegStore();
		if(this.serviceId){
            regStore.serviceId = this.serviceId;
		}
		if(this.redirectUrl){
            regStore.redirectUrl = this.redirectUrl;
		}
		
	}
};
</script>
<style scoped>
@import url(~@/assets/css/form.css);

</style>
<style>
.blur{
   opacity: .6;
}

.blur:hover{
     background: var(--cyan, #248ef9)!important;
      cursor: not-allowed;
}

input:focus {
  /* background-color: #959494; */
  border-top: solid 1px #2b92fa;
  border-bottom: solid 1px #2b92fa;
  border-right: solid 1px #2b92fa;
}
</style>